<p *ngFor="let conf of configs">
  <span>{{ conf.label }}</span>
  <span *ngIf="conf.mask; else noMask">{{
    conf.description | mask : conf.mask
  }}</span>
  <ng-template #noMask>
    {{ conf.description | truncate }}
  </ng-template>
</p>
